module.exports = __webpack_public_path__ + "src/components/Trust/icons/email.png?758672e3";


//////////////////
// WEBPACK FOOTER
// ./src/components/Trust/icons/email.png
// module id = 3119
// module chunks = 8